import { makeStyles, shorthands } from '@fluentui/react-components';

const commonButtonStyle = {
  display: 'flex',
  ...shorthands.padding('12px'),
  justifyContent: 'center',
  alignItems: 'center',
  ...shorthands.gap('8px'),
  ...shorthands.borderRadius('8px'),
  backgroundColor: '#FFF',
  boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.14), 0 0 2px 0 rgba(0, 0, 0, 0.12)',
  ...shorthands.border('none'),
  ...shorthands.outline('none'),
  maxHeight: '150px',
  ...shorthands.overflow('hidden'),
  minWidth: '230px',
};

const commonTextStyle = {
  fontFamily: 'Segoe UI',
  fontStyle: 'normal',
  textAlign: 'left',
  ...shorthands.flex(1, 1, '0px'),
  width: '100%',
  ...shorthands.overflow('hidden'),
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const commonIconStyle = {
  display: 'flex',
  ...shorthands.margin('4px'),
  justifyContent: 'center',
  alignItems: 'center',
  width: '20px',
  height: '20px',
};

export const useAssetsEntryCardStyle = makeStyles({
  fillWidth: {
    ...shorthands.flex(1, 0, '0px'),
  },
  assetsEntryCard: {
    ...commonButtonStyle,
    '& .title': {
      ...commonTextStyle,
      color: '#242424',
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: 600,
    },
    '& .description': {
      ...commonTextStyle,
      color: '#616161',
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: '400',
    },
    '& .text': {
      ...shorthands.flex(1),
      minWidth: '110px',
      width: '100%',
    },
    '& .picture': {
      width: '52px',
      height: '52px',
      '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
      },
    },
    '& .icon': {
      ...commonIconStyle,
    },
  },
});
